module.exports = __webpack_public_path__ + "img/nav_icon_contributions_dk.3809a916.svg";